export default {
  xs: 0,
  sm: 340,
  md: 768,
  lg: 1280,
};
